import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: 17,
    fontWeight: 'bold',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default useStyles;
